import { useState } from "react";
import {
  HeadingGroup,
  OffCanvasLayout,
  Pagination,
  SearchFilters,
  Table,
  ConfirmationBox,
  ModalLayout,
} from "@wac-ui-dashboard/wac_component_library";
import { FaSort } from "react-icons/fa";
import usePodcastList from "./usePodcastList";
import UpdatePodcast from "../updatePodcast";
import BulkUpload from "../BulkUpload";
import MediaBulkUpload from "../../Global/MediaBulkUpload";
import Player from "../../Global/Player";
import Filter from "../Filter";
import Style from "../podcast.module.scss";
import { ImageCard } from "../../Global/ImageCard";

const PodcastList = () => {
  const {
    podcast,
    podcastState,
    activeId,
    currentPage,
    activeFilter,
    showCreateModal,
    paginationOptions,
    isFetching,
    isLoading,
    showDeleteModal,
    audioData,
    videoData,
    showImageModal,
    typeData,
    dataTitle,
    dataId,
    showAudioModal,
    isEditData,
    filterShow,
    dataFileIndex,
    imageData,
    titleImageData,
    basicThumbnailImageData,
    showTitleImageModal,
    showBasicThumbnailImageModal,
    showVideoModal,
    setDataFileIndex,
    setFilterShow,
    handleClearClick,
    handleEditModal,
    handleCreateClick,
    closeDeleteModal,
    handlePagination,
    handlePageSize,
    refetch,
    handleSort,
    handleSearch,
    handlePodcastDataEditClick,
    closeModal,
    deletePodcastDataClick,
    getRow,
    deletePodcast,
    tableFields,
    hasCreatePermission,
    hasEditPermission,
    hasViewPermission,
    hasDeletePermission,
    loadingViewPermission,
    verticalImageData,
    showVerticalImageModal,
    showBulkUpload,
    setShowBulkUpload,
  } = usePodcastList();
  const [showMediaBulkUpload, setShowMediaBulkUpload] = useState(false);
  return (
    <>
      <HeadingGroup
        title={"Podcast"}
        buttonTitle={hasCreatePermission ?? false ? "Add New" : ""}
        extraClassName={`pro-mb-4`}
        handleClick={handleCreateClick}
      >
        {/* Existing Excel bulk upload, hidden in favour of the file bulk upload (implementation kept as is)
        {hasCreatePermission && (
          <button
            type="button"
            className={`pro-btn pro-btn-outline pro-items-center`}
            onClick={() => setShowBulkUpload(true)}
          >
            <span className="material-symbols-outlined">upload_file</span>
            <span>Bulk Upload</span>
          </button>
        )}
        */}
        {hasCreatePermission && (
          <button
            type="button"
            className={`pro-btn pro-btn-outline pro-items-center`}
            onClick={() => setShowMediaBulkUpload(true)}
          >
            <span className="material-symbols-outlined">upload_file</span>
            <span>Bulk Upload</span>
          </button>
        )}
      </HeadingGroup>
      <MediaBulkUpload
        show={showMediaBulkUpload}
        handleClose={() => setShowMediaBulkUpload(false)}
        module={"podcast"}
        refetch={refetch}
      />
      <div className="col-12 pro-pb-6">
        <SearchFilters
          activeFilter={activeFilter}
          onSearchInput={handleSearch}
          loading={isLoading}
          showActions={false}
          handleActionClick={handleEditModal}
          searchInputProps={{ value: podcastState?.search }}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showDateRange={false}
          handleClear={handleClearClick}
          extraFilters={
            <div className="col-auto">
              <button
                className={`pro-btn pro-btn-outline pro-h-100 pro-items-center`}
                onClick={() => setFilterShow(true)}
              >
                <span className="material-symbols-outlined">tune</span>
                <span>Filter</span>
              </button>
            </div>
          }
        />
        <Table
          data={podcast?.data?.original?.data || []}
          uniqueID={"_id"}
          fields={tableFields}
          showCheckBox={hasEditPermission || hasDeletePermission ? true : false}
          SortIcon={<FaSort />}
          handleEdit={handlePodcastDataEditClick}
          editIcon={<span className="material-symbols-outlined">edit</span>}
          handleDelete={deletePodcastDataClick}
          deleteIcon={<span className="material-symbols-outlined">delete</span>}
          handleSort={handleSort}
          getRow={getRow}
          loading={isFetching}
          perpage={podcastState.currentPageSize}
          assignable={false}
          multiSelect={false}
          clear={podcastState.clearSelection}
          editable={hasEditPermission ? true : false}
          deletable={hasDeletePermission ? true : false}
        />
        {podcast?.data?.original?.data?.length > 0 && (
          <Pagination
            currentPage={currentPage}
            totalPageCount={podcast?.data?.original?.last_page_number}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
      </div>
      <ModalLayout
        centered
        show={showDeleteModal}
        handleClose={closeDeleteModal}
      >
        <div className="pro-m-5">
          <ConfirmationBox
            title={`Are you sure you want to delete?`}
            isRight={true}
            cancelText={`Cancel`}
            submitText={`Delete`}
            cancelAction={closeDeleteModal}
            submitAction={deletePodcast}
          >
            ConfirmationBox
          </ConfirmationBox>
        </div>
      </ModalLayout>

      <OffCanvasLayout
        show={showCreateModal}
        handleClose={closeModal}
        title={`${isEditData ? "Update Podcast Details" : "Create Podcast"}`}
        closeIcon={<span className="material-symbols-outlined"> close </span>}
        backdrop={"static"}
      >
        <UpdatePodcast
          activeId={activeId}
          refetch={refetch}
          isEditData={isEditData}
        />
      </OffCanvasLayout>

      <OffCanvasLayout
        show={showBulkUpload}
        handleClose={() => setShowBulkUpload(false)}
        title={"Bulk Upload Podcasts"}
        closeIcon={<span className="material-symbols-outlined"> close </span>}
        backdrop={"static"}
      >
        <BulkUpload
          refetch={refetch}
          handleClose={() => setShowBulkUpload(false)}
        />
      </OffCanvasLayout>

      <OffCanvasLayout
        centered={true}
        show={filterShow}
        handleClose={() => {
          setFilterShow(false);
        }}
        title={"Filter"}
        closeIcon={<span className="material-symbols-outlined">close</span>}
      >
        <Filter setShowform={setFilterShow} refetch={refetch} />
      </OffCanvasLayout>

      <ModalLayout show={showImageModal} handleClose={closeModal}>
        <ImageCard data={imageData} handleClose={closeModal} />
      </ModalLayout>

      <ModalLayout show={showTitleImageModal} handleClose={closeModal}>
        <ImageCard data={titleImageData} handleClose={closeModal} />
      </ModalLayout>

      <ModalLayout show={showBasicThumbnailImageModal} handleClose={closeModal}>
        <ImageCard data={basicThumbnailImageData} handleClose={closeModal} />
      </ModalLayout>

      <ModalLayout show={showVerticalImageModal} handleClose={closeModal}>
              <ImageCard data={verticalImageData} handleClose={closeModal} />
      </ModalLayout>

      <ModalLayout
        centered
        show={showVideoModal}
        handleClose={closeModal}
        propStyle={{ root: Style.modal_root }}
      >
        <Player
          data={videoData}
          dataFileIndex={dataFileIndex}
          setDataFileIndex={setDataFileIndex}
          title={dataTitle}
          dataList={podcast?.data?.original?.data}
          dataId={dataId}
          handleClose={closeModal}
        />
      </ModalLayout>

      {showAudioModal && !showVideoModal && (
        <Player
          data={audioData}
          dataFileIndex={dataFileIndex}
          setDataFileIndex={setDataFileIndex}
          typeData={typeData}
          title={dataTitle}
          dataList={podcast?.data?.original?.data}
          dataId={dataId}
          handleClose={closeModal}
        />
      )}
    </>
  );
};

export default PodcastList;
